import Board from '../board/Board';
import Button from './selector/button/Button';
import Selector from './selector/Selector';
import Title from './title/Title';

const MASK = {
    WIDTH: 671,
    HEIGHT: 870,
};

const TWEEN = {
    DURATION: 250,
    EASE: {
        SHOW: Phaser.Math.Easing.Back.Out,
        HIDE: Phaser.Math.Easing.Back.In,
    },
};

export default class Body extends Phaser.GameObjects.Container {
    private board: Board | null = null;
    private bg!: Phaser.GameObjects.Image;
    private title!: Title;
    private close!: Phaser.GameObjects.Image;
    private shape!: Phaser.GameObjects.Image;
    private selector?: Selector;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupBG();
        this.setupTitle();
        this.setupClose();
        this.setupPanelRanking();
        this.setupMask();
        // this.setupSelector();
        this.onLeaderBoardSelected('User');

        this.setScale(0);
    }

    static get MASK() {
        return MASK;
    }

    setupBG() {
        let frame = 'gui/common/popup_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    setupTitle() {
        let x = 0;
        let y = -486;

        this.title = new Title(this.scene, x, y);
        this.add(this.title);
    }

    setupClose() {
        let x = 270;
        let y = -482;
        let frame = 'icons/close';

        this.close = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.close);

        this.close.setInteractive({ useHandCursor: true });
        this.close.on('pointerdown', () => this.emit('close'));
    }

    setupPanelRanking() {
        let x = 0;
        let y = -380;
        let frame = 'gui/common/panel_ranking';

        // this.panelRanking = this.scene.add.image(x, y, 'atlas', frame);
        // this.add(this.panelRanking);
    }

    setupMask() {
        let x = this.scene.cameras.main.centerX;
        let y = this.scene.cameras.main.centerY - 350;

        this.shape = this.scene.add.image(x, y, 'atlas', 'blank');
        this.shape.setOrigin(0.5, 0);
        this.shape.setDisplaySize(671, 870);
        this.shape.setVisible(false);
    }

    setupSelector() {
        let x = 0;
        let y = 585;

        this.selector = new Selector(this.scene, x, y);
        this.add(this.selector);

        this.selector.on('leaderboard_selected', this.onLeaderBoardSelected, this);
        this.selector.onButtonClick(this.selector.user);
    }

    onLeaderBoardSelected(id: string) {
        this.board?.destroy();
        if (id === Button.ID.SQUADS) return;

        let x = 0;
        let y = -290;

        this.board = new Board(this.scene, x, y);
        this.add(this.board);

        this.board.mask = this.shape.createBitmapMask();
    }

    show(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 1,
                scaleY: 1,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.SHOW,
                onComplete: () => resolve(),
            });
        });
    }

    hide(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 0,
                scaleY: 0,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.HIDE,
                onComplete: () => resolve(),
            });
        });
    }

    destroy() {
        this.shape.destroy();
        super.destroy();
    }
}
